<div class="bgInicio">
    <div class="contentHome">
        <div class="menuCol"  (click)="openModalTurmas()">
            <fa-icon [icon]="['fas', 'calendar-alt']" size="3x"></fa-icon>
           <br>Turmas
        </div>
        <div class="menuCol" (click)="openModal()">
            <fa-icon [icon]="['fas', 'edit']" size="3x"></fa-icon>
            <br>Orçamento
        </div>
        <div class="menuCol" routerLink="/galeria">
            <fa-icon [icon]="['fas', 'camera']" size="3x"></fa-icon>
            <br>Galeria
        </div>
        <div class="menuCol" routerLink="/arquivo">
            <fa-icon [icon]="['fas', 'folder-open']" size="3x"></fa-icon>
            <br>Arquivo
        </div>
    </div>
    <div style="text-align:center;font-size:1.5em;color:#fff;font-weight: 700;width: 100%;top:100px;position: fixed;">
        Bem Vindo {{ usuario }}!
    </div>
</div>
<div id="myModal" class="modal">
    <div class="back" (click)="closeModal()"><fa-icon [icon]="['fas', 'arrow-alt-circle-left']" size="2x"></fa-icon></div>
    <div class="bgInicio">
        <div class="title">
            ORÇAMENTOS
        </div>
        <div class="contentHome">
            <div class="menuCol" routerLink="/orcamento">
                <fa-icon [icon]="['fas', 'graduation-cap']" size="3x"></fa-icon>
                <br>Universitário
            </div>
            <div class="menuCol" routerLink="/orcamento-colegio">
                <fa-icon [icon]="['fas', 'chalkboard-teacher']" size="3x"></fa-icon>
                <br>Colegial
            </div>
        </div>
    </div>
</div>
<div id="myModalTurmas" class="modal">
    <div class="back" (click)="closeModalTurmas()"><fa-icon [icon]="['fas', 'arrow-alt-circle-left']" size="2x"></fa-icon></div>
    <div class="bgInicio">
        <div class="title">
            TURMAS
        </div>
        <div class="contentHome">
            <div class="menuCol" routerLink="/turmas">
                <fa-icon [icon]="['fas', 'graduation-cap']" size="3x"></fa-icon>
                <br>Universitário
            </div>
            <div class="menuCol" routerLink="/turmas-colegio">
                <fa-icon [icon]="['fas', 'chalkboard-teacher']" size="3x"></fa-icon>
                <br>Colegial
            </div>
        </div>
    </div>
</div>